import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IJobTypesService } from "services/JobTypesService";
import { GuidSelectModel } from "services/api/cplapi/CPLAPI";
import { RootState } from "setup";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";

const initialState = {
  JobTypeSelectModels: new Array<GuidSelectModel>(),
  Loading: false,
  LastUpdateTime: new Date(),
};

export const jobTypeSelectSlice = createSlice({
  name: "jobTypeSelect",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getJobTypeSelectModels.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getJobTypeSelectModels.rejected, (state) => {
        state.Loading = false;
      })
      .addCase(getJobTypeSelectModels.fulfilled, (state, action) => {
        state.JobTypeSelectModels = action.payload;
        state.Loading = false;
        state.LastUpdateTime = new Date();
      });
  },
});

export const getJobTypeSelectModels = createAsyncThunk("JobTypes/GetSelectModels", async () => {
  const jobTypesService = container.get<IJobTypesService>(SERVICE_TYPES.JobTypesService);
  return await jobTypesService.getSelectModels();
});

export const selectJobTypeSelectModels = (state: RootState) => {
  return state.jobTypeSelect.JobTypeSelectModels;
};
export const selectLoading = (state: RootState) => {
  return state.jobTypeSelect.Loading;
};
export const selectLastUpdateTime = (state: RootState) => {
  return state.jobTypeSelect.LastUpdateTime;
};

export default jobTypeSelectSlice.reducer;
